// 对应后台管理维护系统的文件类别相关id
export const NodeIdEnum = Object.freeze({
    ARTICLE_TYPE_QYDT_ID: {
        value: '1',
        label: '企业动态'
    },
    ARTICLE_TYPE_HYXW_ID: {
        value: '2',
        label: '赛事动态'
    },
    ARTICLE_TYPE_CJWT_ID: {
        value: '11',
        label: '常见问题'
    },
    ARTICLE_TYPE_SYWH_ID: {
        value: '12',
        label: '使用维护'
    },
    ARTICLE_TYPE_QZ_ID: {
        value: '14',
        label: '产品动态'
    },
    ARTICLE_TYPE_XWDT_ID: {
        value: '15',
        label: '产品动态'
    },
    ARTICLE_TYPE_PLAYER_ID: {
        value: '16',
        label: '球员动态'
    },
    ARTICLE_TYPE_QFDT_ID: {
        value: '18',
        label: '球房动态'
    },
    // 核心：根据value获取对应的label
    getLabelByValue: function(value) {
        // 边界处理：value为空直接返回默认值
        if (!value) return '未知分类';
        // 遍历枚举的所有属性
        for (const key in this) {
            // 过滤工具方法本身，只处理包含value/label的枚举项
            const item = this[key];
            if (typeof item === 'object' && item.hasOwnProperty('value') && item.hasOwnProperty('label')) {
                // 精准匹配value（注意类型一致，比如字符串/数字）
                if (item.value === String(value)) {
                    return item.label;
                }
            }
        }
        // 无匹配项返回默认值
        return '未知分类';
    }
});